module.exports = "query GetMarketingURL($title: String!) {\n  marketingUrl(title: $title) {\n    ...MarketingURLFragment\n  }\n}\n"